import {
  CompanyProductSetQuality,
  ResolverQualityLevel,
  SpecialProductSetQuality,
} from '../../internal/product-resolver/types';

export function friendlyProductSetQuality(productSetQuality: CompanyProductSetQuality | undefined): string | undefined;
export function friendlyProductSetQuality(productSetQuality: undefined): undefined;
export function friendlyProductSetQuality(productSetQuality: CompanyProductSetQuality): string;
export function friendlyProductSetQuality(productSetQuality: CompanyProductSetQuality | undefined): string | undefined {
  switch (productSetQuality) {
    case undefined:
      return undefined;
    case ResolverQualityLevel.HIGH:
      return 'High quality';
    case ResolverQualityLevel.MEDIUM_PLUS:
      return 'Medium+ quality';
    case ResolverQualityLevel.MEDIUM:
      return 'Medium quality';
    case ResolverQualityLevel.LOW:
      return 'Low quality';
    case ResolverQualityLevel.VERY_LOW:
      return 'Very low quality';
    case ResolverQualityLevel.POOR:
      return 'Poor quality';
    case SpecialProductSetQuality.MANUAL:
      return 'Manual';
    case SpecialProductSetQuality.MANUAL_INHERITED:
      return 'Manual (inherited)';
    case SpecialProductSetQuality.MICROWORK:
      return 'Microwork';
    case SpecialProductSetQuality.GPT:
      return 'GPT';
    case SpecialProductSetQuality.LITE:
      return 'Lite resolver';
    case SpecialProductSetQuality.OTHER:
      return 'Unknown quality';
    case SpecialProductSetQuality.NONE:
      return 'No products';
    default:
      return 'Unknown quality';
  }
}
